import { render, staticRenderFns } from "./oncecard.vue?vue&type=template&id=b2241fb2&"
import script from "./oncecard.vue?vue&type=script&lang=js&"
export * from "./oncecard.vue?vue&type=script&lang=js&"
import style0 from "./oncecard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports